"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var cartForm = document.querySelector('form[action="/cart"]');
  if (!cartForm) return;
  var checkoutButton = cartForm.querySelector('button[type="submit"][name="checkout"]');
  var cartNote = cartForm.querySelector('[name="note"]');
  checkoutButton.disabled = !cartForm.checkValidity();
  cartNote.rows = cartNote.textContent.split(/(?:\r\n|\n|\r)/).length - 1;

  // Order the note fields explicitly so the free-text Delivery Instructions
  // come first. Some carriers truncate the note at a character limit, which was
  // cutting off the instructions when they sat at the end (DPIR-1237). This must
  // stay in sync with the note textarea order in wholesale-order-attributes.liquid.
  var NOTE_FIELD_ORDER = ['Delivery Instructions', 'Delivery Hours Start', 'Delivery Hours End', 'Hand Unload Required', 'Forklift', 'Authority To Leave'];

  var getAttributeKey = function getAttributeKey(element) {
    var match = (element.name || '').match(/attributes\[(.*)\]/);
    return match ? match[1] : '';
  };

  var updateCartNote = function updateCartNote() {
    var attributeElements = Array.from(cartForm.elements).filter(function (element) {
      return element.matches('[name*="attributes"]') && !element.matches('[data-no-note]');
    });
    attributeElements.sort(function (a, b) {
      var aIndex = NOTE_FIELD_ORDER.indexOf(getAttributeKey(a));
      var bIndex = NOTE_FIELD_ORDER.indexOf(getAttributeKey(b));
      // Unlisted fields keep their relative DOM order at the end of the note.
      if (aIndex === -1) aIndex = NOTE_FIELD_ORDER.length;
      if (bIndex === -1) bIndex = NOTE_FIELD_ORDER.length;
      return aIndex - bIndex;
    });
    var updatedNoteValue = "";
    attributeElements.forEach(function (element) {
      updatedNoteValue += "".concat(element.value, "|");
    });
    cartNote.textContent = updatedNoteValue;
    cartNote.rows = cartNote.textContent.split(/(?:\r\n|\n|\r)/).length - 1;
  };

  var writableElements = Array.from(cartForm.elements).filter(function (element) {
    return element.matches('textarea') || element.matches('[type="text"]');
  });
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    var _loop = function _loop() {
      var input = _step2.value;
      input.addEventListener('keyup', function (e) {
        input.value = input.value.replace('|', '');
        updateCartNote();
      });
    };

    for (var _iterator2 = writableElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
        _iterator2["return"]();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var handleCartFormChange = function handleCartFormChange(event) {
    updateCartNote();
    checkoutButton.disabled = !cartForm.checkValidity();
  };

  cartForm.addEventListener('change', handleCartFormChange);

});